import { TreeSelect, TreeSelectProps } from "antd";
import React, { useMemo } from "react";
import {
  SourceTreeSelectData,
  useSourceTreeSelectData,
} from "../hooks/useSourceTreeSelectData";

type CustomFormItemProps = {
  value?: string;
  onChange?: (workplace: string) => void;
  filterByRootId?: string;
} & TreeSelectProps;

export const SourceSelect: React.FC<CustomFormItemProps> = (props) => {
  const treeData = useSourceTreeSelectData();
  const filterRoot: SourceTreeSelectData | false = useMemo(
    () => props.filterByRootId && findFilterRootById(treeData),
    [treeData, props.filterByRootId]
  );

  function findFilterRootById(data: SourceTreeSelectData[]) {
    for (const item of data) {
      if (item.value === props.filterByRootId) return item;

      if (item.children) {
        const found = findFilterRootById(item.children);
        if (found) return found;
      }
    }
    return undefined;
  }

  return (
    <TreeSelect
      showSearch
      style={{ width: "100%" }}
      styles={{
        popup: {
          root: {
            maxHeight: 400,
            overflow: "auto",
          },
        },
      }}
      allowClear
      treeDefaultExpandAll
      treeData={
        props.filterByRootId && filterRoot ? filterRoot.children : treeData
      }
      treeNodeFilterProp="title"
      onClear={() => props.onChange?.(undefined)}
      {...props}
    />
  );
};
